import Cookies from "universal-cookie";

const COOKIE_NAME = "tabl_attrib";
const COOKIE_MAX_AGE_DAYS = 30;

const ALLOWED_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "call_id",
  "cid", // call id short
];

export function captureUtmFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const picked = {};

  ALLOWED_KEYS.forEach((key) => {
    const val = params.get(key);
    if (val) picked[key] = val;
  });

  return Object.keys(picked).length > 0 ? picked : null;
}

export function saveUtmToCookie(incoming) {
  const cookies = new Cookies();
  const existing = cookies.get(COOKIE_NAME) || {};

  // merge (last-touch wins)
  const merged = { ...existing, ...incoming, last_touch_ts: Date.now() };

  cookies.set(COOKIE_NAME, merged, {
    path: "/",
    maxAge: COOKIE_MAX_AGE_DAYS * 24 * 60 * 60,
    sameSite: "lax"
  });

  return merged;
}

export function readUtmFromCookie() {
  const cookies = new Cookies();
  return cookies.get(COOKIE_NAME) || null;
}